import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { z } from 'zod'
import { AuthLayout } from '@/components/auth/auth-layout'
import { UserCircle } from '@phosphor-icons/react'
import { completeLoginWithTokens } from '@/lib/complete-login-with-tokens'

const googleContinueSearchSchema = z.object({
  access_token: z.string().min(30),
  next: z.string().max(500).optional(),
  return_app: z.enum(['suporte', 'admindesk']).optional(),
})

export const Route = createFileRoute('/auth/google/continue')({
  validateSearch: googleContinueSearchSchema,
  component: AuthGoogleContinuePage,
})

function AuthGoogleContinuePage() {
  const search = useSearch({ from: '/auth/google/continue' })
  const navigate = useNavigate()
  const applied = useRef(false)

  useEffect(() => {
    if (applied.current) return
    applied.current = true

    void (async () => {
      const ok = await completeLoginWithTokens(
        {
          accessToken: search.access_token,
        },
        {
          returnApp: search.return_app,
          next: search.next,
        },
      )
      if (!ok) {
        navigate({ to: '/', replace: true })
      }
    })()
  }, [navigate, search])

  return (
    <AuthLayout contentMaxWidthClassName="max-w-sm">
      <div className="flex flex-col items-center gap-6 py-2 text-center">
        <div
          className="relative flex size-20 items-center justify-center"
          aria-hidden
        >
          <span className="absolute inset-0 rounded-full border-2 border-indigo-100 bg-indigo-50/80" />
          <span className="absolute inset-0 animate-[spin_1.1s_linear_infinite] rounded-full border-2 border-transparent border-t-indigo-600 border-r-indigo-400/40" />
          <UserCircle
            weight="duotone"
            className="relative z-[1] size-9 text-indigo-600 animate-pulse"
          />
        </div>
        <div className="space-y-2 animate-auth-item-enter">
          <h1 className="font-heading text-lg font-semibold tracking-tight text-slate-900">
            Conectando sua conta
          </h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Estamos finalizando o login com o Google.
          </p>
        </div>
      </div>
    </AuthLayout>
  )
}
